import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import Layout from "../themes";
import Login from "@/pages/Login";
import UsersPage from "@/apsales/Users";
import TeamsPage from "@/apsales/Teams";
import ProductsPage from "@/apsales/Products";
import DistributorsPage from "@/pages/Distributors";
import AddDistributor from "@/pages/Distributors/Add";
import EditDistributor from "@/pages/Distributors/Edit";
import AddUser from "@/apsales/Users/Add";
import EditUser from "@/apsales/Users/Edit";
import AddTeam from "@/apsales/Teams/Add";
import EditTeam from "@/apsales/Teams/Edit";
import AssignUser from "@/apsales/Teams/AssignUser";
import AssignOutlet from "@/apsales/Teams/AssignOutlet";
import AssignProduct from "@/apsales/Teams/AssignProduct";
import AddProduct from "@/apsales/Products/Add";
import EditProduct from "@/apsales/Products/Edit";
import PackTypePage from "@/apsales/PackType";
import AddPackType from "@/apsales/PackType/Add";
import EditPackType from "@/apsales/PackType/Edit";
import ProductGroupPage from "@/apsales/ProductGroup";
import AddProductGroup from "@/apsales/ProductGroup/Add";
import EditProductGroup from "@/apsales/ProductGroup/Edit";
import ProductTypePage from "@/apsales/ProductType";
import AddProductType from "@/apsales/ProductType/Add";
import EditProductType from "@/apsales/ProductType/Edit";
import TeamCategoryPage from "@/apsales/TeamCategory";
import AddTeamCategory from "@/apsales/TeamCategory/Add";
import EditTeamCategory from "@/apsales/TeamCategory/Edit";
import RegionPage from "@/apsales/Region";
import AddRegion from "@/apsales/Region/Add";
import EditRegion from "@/apsales/Region/Edit";
import StockInListPage from "@/pages/StockIn";
import AddStockInPage from "@/pages/StockIn/Add";
import EditStockInPage from "@/pages/StockIn/Edit";
import ViewStockInPage from "@/pages/StockIn/View";
import StockOutListPage from "@/pages/StockOut";
import AddStockOutPage from "@/pages/StockOut/Add";
import ViewStockOutPage from "@/pages/StockOut/View";
import ReimbursementsPage from "@/pages/Reimbursements";
import TradeInPage from "@/pages/TradeIn";
import RebatesPage from "@/pages/Rebates";
import RebateLedgerPage from "@/pages/RebateLedger";
import BankInSlipsPage from "@/pages/BankInSlips";
import TeamSalesDataPage from "@/pages/TeamSalesData";
import MasterStockDataPage from "@/pages/MasterStockData";

function Router() {
  return useRoutes([
    { path: "/login", element: <Login /> },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <MasterStockDataPage />,
        },
        { path: "master-stock-data", element: <MasterStockDataPage /> },
        { path: "stock-in", element: <StockInListPage /> },
        { path: "stock-in/add", element: <AddStockInPage /> },
        { path: "stock-in/:id/edit", element: <EditStockInPage /> },
        { path: "stock-in/:id", element: <ViewStockInPage /> },
        { path: "stock-out", element: <StockOutListPage /> },
        { path: "stock-out/add", element: <AddStockOutPage /> },
        { path: "stock-out/:id", element: <ViewStockOutPage /> },
        { path: "bank-in-slip", element: <BankInSlipsPage /> },
        { path: "stock-movements", element: <Navigate to="/bank-in-slip" replace /> },
        { path: "trade-in", element: <TradeInPage /> },
        { path: "reimbursements", element: <ReimbursementsPage /> },
        { path: "rebates", element: <RebatesPage /> },
        { path: "rebate-ledger", element: <RebateLedgerPage /> },
        { path: "team-data", element: <TeamSalesDataPage /> },
        { path: "users", element: <UsersPage /> },
        { path: "users/add", element: <AddUser /> },
        { path: "users/:id/edit", element: <EditUser mode="edit" /> },
        { path: "teams", element: <TeamsPage /> },
        { path: "teams/add", element: <AddTeam /> },
        { path: "teams/:id/edit", element: <EditTeam mode="edit" /> },
        { path: "teams/:id/assign-user", element: <AssignUser /> },
        { path: "teams/:id/assign-outlet", element: <AssignOutlet /> },
        { path: "teams/:id/assign-product", element: <AssignProduct /> },
        { path: "team-categories", element: <TeamCategoryPage /> },
        { path: "team-categories/add", element: <AddTeamCategory /> },
        { path: "team-categories/:id/edit", element: <EditTeamCategory mode="edit" /> },
        { path: "regions", element: <RegionPage /> },
        { path: "regions/add", element: <AddRegion /> },
        { path: "regions/:id/edit", element: <EditRegion mode="edit" /> },
        { path: "products", element: <ProductsPage /> },
        { path: "products/add", element: <AddProduct /> },
        { path: "products/:id/edit", element: <EditProduct mode="edit" /> },
        { path: "product-groups", element: <ProductGroupPage /> },
        { path: "product-groups/add", element: <AddProductGroup /> },
        { path: "product-groups/:id/edit", element: <EditProductGroup mode="edit" /> },
        { path: "product-types", element: <ProductTypePage /> },
        { path: "product-types/add", element: <AddProductType /> },
        { path: "product-types/:id/edit", element: <EditProductType mode="edit" /> },
        { path: "pack-types", element: <PackTypePage /> },
        { path: "pack-types/add", element: <AddPackType /> },
        { path: "pack-types/:id/edit", element: <EditPackType mode="edit" /> },
        { path: "distributors", element: <DistributorsPage /> },
        { path: "distributors/add", element: <AddDistributor /> },
        { path: "distributors/:id/edit", element: <EditDistributor mode="edit" /> },
      ],
    },
    { path: "*", element: <Navigate to="/" replace /> },
  ]);
}

export default Router;

